<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="layout df fdc ">
        <div class="layout_top df aic jcc fn">
            <template v-if="!isOnboardingRoute && cafeInfo && cafeInfo.logo">
                <img :src="cafeInfo.logo" :alt="cafeInfo.cafename" class="cafe-logo">
                <span class="cafe-name">{{ cafeInfo.cafename }}</span>
            </template>
            <img v-else src="../assets/imgs/image.png" alt="Lazygrid" class="platform-logo">
        </div>
        <div class="layout_mid f1">
            <router-view></router-view>
        </div>
        <div v-if="!isOnboardingRoute && cafeInfo" class="layout_footer df aic jcc">
            <span class="powered-by">Powered by Lazygrid</span>
        </div>
    </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import session from '@/utils/session'

const $store = useStore()
const route = useRoute()
const cafeInfo = computed(() => $store.state.user.cafe_info)
const isOnboardingRoute = computed(() => Boolean(route.meta.onboarding))

onMounted(() => {
    if (isOnboardingRoute.value) return
    const cafe_id = session.get('cafe_id')
    if (cafe_id) {
        $store.dispatch('user/A_get_cafe_info', cafe_id).catch(() => {})
    }
})
</script>

<style lang="scss" scoped>

.layout{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    
    .layout_top{
        height: 60px;
        border-bottom: 1px solid #E3E8E5;
        background: #fff;
        img{
            height: 30px;
            margin: 0 12px;
        }
        .cafe-logo{
            max-height: 40px;
            max-width: 120px;
            object-fit: contain;
            margin-right: 12px;
        }
        .cafe-name{
            font-size: 18px;
            font-weight: 600;
            color: #17231D;
            max-width: 380px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .platform-logo{
            height: 30px;
        }
    }
    .layout_mid{
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .layout_footer{
        height: 40px;
        border-top: 1px solid #F3F4F6;
        background: #F7F8F6;
        .powered-by{
            font-size: 12px;
            color: #9CA3AF;
            font-weight: 400;
        }
    }
}

@media screen and  (min-width: 600px){
    .layout{
        width: 560px;
        height: auto;
        border: 1px solid #DDE4E0;
        box-shadow: 0 24px 70px rgba(23, 35, 29, 0.12);
        border-radius: 14px;
        background: #fff;
        .layout_top{
            justify-content: flex-start;
        }
        .layout_footer{
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
    }
}
</style>
